import { InitialAssessmentConstants } from './initialAssessment.constants'
import { IInitialAssessmentAction, IInitialAssessmentState } from './initialAssessment.types'

export const initialAssessmentState: IInitialAssessmentState = {
  selectedOption: InitialAssessmentConstants.NEURO,
  __areDefaultsSet: false,
}

export function initialAssessmentReducer(
  state: IInitialAssessmentState = initialAssessmentState,
  action: IInitialAssessmentAction
): IInitialAssessmentState {
  switch (action.type) {
    case InitialAssessmentConstants.SET_SELECTED_OPTION:
      return { ...state, selectedOption: action.selectedOption }
    case InitialAssessmentConstants.SET_PR_NABC_DEFAULTS:
      return { ...state, __areDefaultsSet: action.__areDefaultsSet }
    default:
      return state
  }
}
